module.exports = __webpack_public_path__ + "0b27027278ad367e4d6645c72f289207.jpg";